export default __webpack_public_path__ + "static/media/accordionIconClose.dd4fbb69.svg";